import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { QuizQuestion, QuizAnswerResponse } from '../../shared/models';
import { MarkdownService } from '../../../services/markdown.service';

@Component({
  selector: 'ut-academy-quiz-result-item',
  templateUrl: './quiz-result-item.component.html',
  styleUrls: ['./quiz-result-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QuizResultItemComponent {
  @Input() questionNumber = 0;
  @Input() totalQuestions = 0;
  @Input() question: QuizQuestion | null = null;
  @Input() result: QuizAnswerResponse | null = null;

  @Output() reviewLessonClicked = new EventEmitter<string>();

  constructor(
    private markdownService: MarkdownService,
  ) {}

  getQuestionHtml(content: string): string {
    if (!content) return '';
    return this.markdownService.renderMarkdown(content);
  }

  get isCorrect(): boolean {
    return !!this.result?.correct_answer;
  }

  get courseTitle(): string {
    return this.question?.course?.title || '';
  }

  onReviewLesson(): void {
    if (this.result) {
      this.reviewLessonClicked.emit(this.result.course_slug);
    }
  }
}
